/* eslint-disable import/prefer-default-export */
import { useContext } from "react";
import { MobileMenuContext } from "./MobileMenuContext";

export const useMobileMenu = () => useContext(MobileMenuContext);
